import React from 'react'
import { CSSTransition } from 'react-transition-group'
import './info.css'

// const info = 
// `2019/11/27
// - 新增日文、英文
// - 因應國際化功能，刪除動態載入
// - 畫面和排版調整
// - 滑鼠移動到護符上，會顯示護符ID
// - 取得分類新增「合作」

// 2019/11/13
// - 觸發條件選項新增「起死回生」
// - 篩選條件新增「取得方式」
// - 滑鼠移動到護符上，會更改為突破圖片
// - 滑鼠移動到護符上，會顯示取得方式
// - 修正於Edge上的bug (IE仍無法用)

// 2019/10/18
// - 修正文字錯誤

// 2019/10/16
// - 效果選項補上「Overdrive特攻」

// 2019/10/14
// - 修正效果選擇「HP」時的Bug
// - 排列順序改為由新到舊
// - 點選護符後，會開啟wiki分頁
// - 部分視覺細節調整

// 2019/10/8
// - 網站上架`

const info = `Making new wbsite...`


function Info(props) {
  return (
    <CSSTransition classNames='info' in={props.info.active} timeout={250}>
      <div className='info' >
        <div className='info-div'>
          <pre className='info-content'>{info}</pre>
        </div>
      </div>
    </CSSTransition>
  )
}

export default Info